import { KeyboardEvent, useEffect, useState } from 'react';
import { useStepsStore } from '../stores/StepsStore';
import VerificationMethodsChoose from './fragments/VerificationMethodsChoose';

const Step_VerifyOrder = (props: { onNext: () => void; openFindOrderIDModal: () => void; }) => {
  const { setVerificationBitUsedRepeat, setVerificationType, bitUsedRepeat, available_verifications, error } = useStepsStore();

  const setSourceUsedRepeatWrapper = (value: string) => {
    const cleanVal = value.replaceAll('_', '').replaceAll(' ', '').toUpperCase().trim();
    setVerificationBitUsedRepeat(cleanVal);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      props.onNext();
    }
  };

  const openCloseOrderIdImg = () => {
    props.openFindOrderIDModal();
  };

  useEffect(() => {
    if (available_verifications.zip.available) {
      setVerificationType('zip');
    }
  }, [available_verifications]);


  return (
    <div>
      <div className='margin-top'>
        <h2 className='ncf-title'>Verification</h2>
        <p className='step-explain wider-step'>
          To verify your subscription and alarm purchase, please enter the postcode that your order was sent to, or the postcode you gave for your alarm at your medical referral.
        </p>
      </div>
      <div className="simple-form">
        <VerificationMethodsChoose show={false} />
        {available_verifications.email.available && false ?
          <>
            <label htmlFor="name">Enter first digits of the email used:</label>
            <div className="input-wrapper sufix-input-wrapper">
              <input
                id="name" type="text"
                autoComplete='off'
                placeholder="_ _ _ _" required
              />
              <span className="bit-suffix">{available_verifications.email.bit}</span>
            </div>
            <p className='step-explain'>Use the email address used to purchase the alarm</p>
          </>
          : ''}
        {available_verifications.phone.available && false ?
          <>
            <label htmlFor="name">Enter the last digits of the phone used:</label>
            <div className="input-wrapper prefix-input-wrapper">
              <span className="bit-prefix">{available_verifications.phone.bit}</span>
              <input
                id="name"
                type="text"
                autoComplete='off'
                placeholder="_ _ _ _" required
              />
            </div>
            <p className='step-explain'>Use the phone used to purchase the alarm</p>
          </>
          : ''}
        {available_verifications.source.available && false ?
          <>
            <label htmlFor="name">Enter the last 4 digits of the Order Id:</label>
            <div className="input-wrapper prefix-input-wrapper">
              <span className="bit-prefix">{available_verifications.source.bit}</span>
              <input
                id="name"
                type="text"
                autoComplete='off'
                onKeyDown={handleKeyDown}
                onBlur={(e) => setSourceUsedRepeatWrapper(e.target.value)}
                maxLength={4}
                required
              />
              <div className="find-order-id-box">
                <div className='find-order-id' onClick={openCloseOrderIdImg}>
                  <span>Find you Order ID </span><button onClick={openCloseOrderIdImg}><img width={'30px'} height={'auto'} src={(window as any).order_label_id_img} /></button>
                </div>
              </div>
            </div>
            <p className='step-explain'>You can find the Order Id in your purhcase confirmation email</p>
          </>
          : ''}
        {available_verifications.zip.available ?
          <>
            <label htmlFor="name">Please enter the postcode. The first two characters are already entered for you.</label>
            <div className="input-wrapper prefix-input-wrapper">
              <span className="bit-prefix">{available_verifications.zip.bit}</span>
              <input
                id="name"
                type="text"
                autoComplete='off'
                className='small-prefix'
                onKeyDown={handleKeyDown}
                onBlur={(e) => setSourceUsedRepeatWrapper(e.target.value)}
                value={bitUsedRepeat ?? ''}
                onChange={(e) => setSourceUsedRepeatWrapper(e.target.value)}
                required
              />
            </div>
            <p className='step-explain explain-small'>This must be the postcode your order was delivered to or the postcode you gave at your medical referral.</p>
          </>
          : ''}
        {error !== '' ? <div className="error" dangerouslySetInnerHTML={{ __html: error }}></div> : ''}
      </div>
    </div>
  );
};

export default Step_VerifyOrder;